import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Box, Drawer, CssBaseline, Toolbar, Divider, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { useAppDispatch, useAppSelector } from 'src/store/index'
import { logout } from 'src/store/slice/LoginSlice'
import MuiButton from 'src/components/mui/MuiButton'
import { StyledMain, StyledAppBar, StyledDrawerHeader } from './components/Styleds'
import MainToolbarText from './components/MainToolbarText'
import MainToolbarUser from './components/MainToolbarUser'
import MainToolbarLinearProgress from './components/MainToolbarLinearProgress'
import * as LoginService from 'src/services/LoginService'
import MainMenu from './components/MainMenu'
import './Main.css'

const MainLayout = () => {
  const dispatch = useAppDispatch()
  const { logined, userInfo } = useAppSelector((state) => state.LoginSlice)
  const drawerWidth = 240
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  
  const logoutButtonClick = () => {
    LoginService.logout((resp) => {
      if (resp.success) dispatch(logout())
    })
  }

  if (!logined) {
    return <Navigate to="/login" />
  }
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <CssBaseline />
      <StyledAppBar position="fixed" className='appbar' open={open} drawerwidth={drawerWidth}>
        <Toolbar className='tool-bar-root'>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => { setOpen(true) }}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <MainToolbarLinearProgress />
          <div className="toolbar-header">
            <MainToolbarText />
            <MuiButton color="inherit" variant="text" size="small" onClick={logoutButtonClick} endIcon={<ExitToAppIcon />}>
              <MainToolbarUser userInfo={userInfo} />
            </MuiButton>
          </div>
        </Toolbar>
      </StyledAppBar>
      <Drawer
        sx={{ width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' } }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <StyledDrawerHeader>
          <IconButton onClick={() => { setOpen(false) }}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </StyledDrawerHeader>
        <Divider />
        <MainMenu />
      </Drawer>
      <StyledMain open={open} drawerwidth={drawerWidth}>
        <StyledDrawerHeader />
        <Outlet />
      </StyledMain>
    </Box>
  )
}

export default MainLayout
